export default "__VITE_ASSET__CefwoZTq__"